<div appTheme>
    <div class="modal-box scrolling">
        <form (ngSubmit)="resendValidationEmail(resendForm)" #resendForm="ngForm">
            <div class="modal-box-container main-container">
                <h1>Resend Validation Email</h1>
                <div class="col-sm-12">
                    <p>Enter your email address to resend the registration validation email.</p>
                    <span class="error-text">{{error}}</span>
                    <input
                        class="input-text"
                        type="email"
                        name="validationEmail"
                        [ngModel]="validationEmail"
                        placeholder="Email"
                        validationEmail
                        required
                        maxlength="50"
                        #validationEmailRef="ngModel"
                        pattern="[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}"
                    />
                    <span class="help-block" *ngIf="!validationEmailRef.valid && validationEmailRef.touched">Please enter a valid email.</span>
                    <div class="bottom">
                        <button class="submit-button button-large" id="resendBtn" [disabled]="!resendForm.valid">
                            Resend Validation email <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                        <button class="cancel-button button-small" id="cancelBtn" (click)="goToMain()">Cancel</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div *ngIf="isLoading" class="modal-box scrolling">
    <app-loading [text]="'Sending validation email...'" [size]="'fa-5x'"></app-loading>
</div>
